export const clientType={DESKTOP:'DESKTOP',MOBILE:'MOBILE'};